import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useAdminService } from '~/services';
import { OrgNameTinType, formatOrgName } from '~/util';
import { EntityTypeType, UserRoleType } from '~/components/Admin';

interface RemoveRoleProps {
    entityType: EntityTypeType;
    role: UserRoleType;
    setIsRemoving: (x: boolean) => void;
}
export function RemoveRole({ entityType, role, setIsRemoving }: RemoveRoleProps) {
    const { removeUserRole } = useAdminService();
    const [loading, setLoading] = React.useState(false);

    async function remove() {
        try {
            setLoading(true);
            await removeUserRole(role.id, entityType);
            // This component will go away as soon as this finishes
        } catch (e) {
            setLoading(false);
        }
    }
    return (
        <div>
            <div className="text-danger fw-bold mt-2">
                Are you sure you want to remove access to{' '}
                {entityType === 'organization'
                    ? formatOrgName(role[entityType] as OrgNameTinType)
                    : role[entityType]?.name}
                ? This action cannot be undone.
            </div>
            <div className="text-end mb-2">
                <button
                    type="button"
                    className="btn btn-danger"
                    onClick={remove}
                    disabled={loading}
                >
                    Remove
                    {loading && (
                        <Spinner
                            animation="border"
                            variant="light"
                            size="sm"
                            role="status"
                            className="ms-1"
                        />
                    )}
                </button>
                <button
                    type="button"
                    className="btn btn-secondary ms-2"
                    onClick={() => setIsRemoving(false)}
                >
                    Cancel
                </button>
            </div>
        </div>
    );
}
